import Modal from 'developer_components/newModal';
import Simplebar from 'simplebar';

function HotelMapModal(options = {}) {
    const $element = Modal.createFromHTML(`
        <div class="Hotel-map-modal__header">
            <div class="Hotel-map-modal__close js-modalClose">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.307 7.69289C16.6976 8.08342 16.6976 8.71658 16.307 9.10711L13.4142 12L16.307 14.8929C16.6976 15.2834 16.6976 15.9166 16.307 16.3071C15.9165 16.6976 15.2834 16.6976 14.8928 16.3071L11.9999 13.4142L9.10705 16.3071C8.71653 16.6976 8.08336 16.6976 7.69284 16.3071C7.30231 15.9166 7.30231 15.2834 7.69284 14.8929L10.5857 12L7.69284 9.10711C7.30231 8.71658 7.30231 8.08342 7.69284 7.69289C8.08336 7.30237 8.71653 7.30237 9.10705 7.69289L11.9999 10.5858L14.8928 7.69289C15.2834 7.30237 15.9165 7.30237 16.307 7.69289Z" fill="#2A2536"></path>
                </svg>
            </div>
        </div>
        <div class="Hotel-map-modal__content js-mapModalContent"></div>
    `, { id: 'hotel-map-modal', className: 'Hotel-map-modal' });

    Modal.call(this, $element, options);

    this.$hotelMapBlock     = document.getElementById('HotelMapBlock');

    if (!this.$hotelMapBlock) {
        return;
    }
    
    this.$panoramaContainer = document.getElementById('PanoramaContainer');
    this.$mapContainer      = document.getElementById('MapContainer');
    this.$map               = document.getElementById('Map');
    this.$hotelMapModal     = document.getElementById('hotel-map-modal');
    this.$mapSector         = document.querySelector('.js-mapSector');

    this.$distances         = this.$mapSector.querySelector('.Text-Block');
    this.$mapModalContent   = this.$hotelMapModal.querySelector('.js-mapModalContent');

    this.on('open', () => {
        this._addMapBlock();
        this._updateMapSize();
        this._addParam();
    });

    this.on('close', () => {
        this._removeMapBlock();
        this._updateMapSize();
    });
}

HotelMapModal.prototype = Object.create(Modal.prototype);
Object.defineProperty(HotelMapModal.prototype, 'constructor', {
    value: HotelMapModal,
    enumerable: false,
    writable: true,
});

/**
 * Добавляет блок с картой в модалку, но удаляет со страницы
 */
HotelMapModal.prototype._addMapBlock = function() {
    this.$hotelMapModalContent = this.$hotelMapModal.querySelector('.js-hotelMapModalContent');
    this.$mapSector = document.querySelector('.js-mapSector');

    this.$mapModalContent.append(this.$mapSector);
    this.$map.insertAdjacentHTML('beforeend', 
        '<div class="Hotel-map-modal__wrapper js-hotelMapModalWrapper"></div>'
    );

    const $hotelMapModalWrapper = this.$mapModalContent.querySelector('.js-hotelMapModalWrapper');

    $hotelMapModalWrapper.append(
        this.$mapContainer,
        this.$panoramaContainer,
        this.$distances
    );

    new Simplebar($hotelMapModalWrapper, {
        autoHide: false,
    });
}

/**
 * Удаляет блок с картой из модалки и возвращает обратно на страницу
 */
HotelMapModal.prototype._removeMapBlock = function() {
    this.$mapSector = document.querySelector('.js-mapSector');

    this.$map.append(
        this.$mapContainer, 
        this.$panoramaContainer, 
        this.$distances
    );

    this.$map.querySelector('.js-hotelMapModalWrapper').remove();

    this.$hotelMapBlock.append(this.$mapSector);
}

/**
 * Обновление размера карты
 */
HotelMapModal.prototype._updateMapSize = function() {
    this.options.map.fitToViewport();
}

/**
 * Добавляет параметр
 */
HotelMapModal.prototype._addParam = function() {
    const url = new URL(window.location.href);

    url.searchParams.append('on_map', 1);

    window.history.replaceState({}, 'Объект на карте', url.href);
}

export default HotelMapModal;